import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { PostHogService } from 'src/app/shared/services/posthog.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { ForgotPasswordComponent } from './auth/components/forgot-password/forgot-password.component';
import { LoginComponent } from './auth/components/login/login.component';
import { RegisterComponent } from './auth/components/register/register.component';
import { ResetPasswordComponent } from './auth/components/reset-password/reset-password.component';
import { AuthService } from './auth/components/services/auth.service';
import { sellrPreset } from './custom-preset';
import { CustomersModule } from './customers/customers.module';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { NavBarComponent } from './shared/components/nav-bar/nav-bar.component';
import { SideBarComponent } from './shared/components/side-bar/side-bar.component';
import { ApiInterceptorService } from './shared/interceptors/api.interceptor.service';
import { AuthInterceptorService } from './shared/interceptors/auth.interceptor.service';
import { NetworkInterceptor } from './shared/interceptors/network.interceptor.service';
import { PrimengModule } from './shared/primeng/primeng.module';
import { UserResolver } from './shared/resolvers/user.resolver';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        RegisterComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        AuthLayoutComponent,
        MainLayoutComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        CommonModule,
        AppRoutingModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        NgOptimizedImage,
        PrimengModule,
        FormsModule,
        AuthModule,
        SideBarComponent,
        CustomersModule,
        NavBarComponent,
    ],
    providers: [
        AuthService,
        HttpClient,
        Router,
        {
            provide: APP_INITIALIZER,
            useFactory: (posthogService: PostHogService) => () => posthogService,
            deps: [PostHogService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptorService,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true,
        },
        UserResolver,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: NetworkInterceptor,
            multi: true,
        },
        providePrimeNG({
            theme: {
                preset: sellrPreset,
                options: {
                    darkModeSelector: '.dark-mode',
                },
            },
            translation: {
                today: 'اليوم',
                accept: 'قبول',
                clear: 'اعادة ضبط',
                monthNames: [
                    'يناير',
                    'فبراير',
                    'مارس',
                    'ابريل',
                    'مايو',
                    'يونيو',
                    'يوليو',
                    'اغسطس',
                    'سبتمبر',
                    'اكتوبر',
                    'نوفمبر',
                    'ديسمبر',
                ],
                monthNamesShort: [
                    'يناير',
                    'فبراير',
                    'مارس',
                    'ابريل',
                    'مايو',
                    'يونيو',
                    'يوليو',
                    'اغسطس',
                    'سبتمبر',
                    'اكتوبر',
                    'نوفمبر',
                    'ديسمبر',
                ],
            },
        }),
        MessageService,
        provideHttpClient(withInterceptorsFromDi()),
    ],
    schemas: [NO_ERRORS_SCHEMA],
})
export class AppModule {}
